import React from 'react';

import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import { Button, QuantityControl, Typography } from '../../../components/atoms';

type Props = {
  itemName: string;
  handleAddItem: (quantity: number) => any;
  quantity: number;
  setQuantity: (newQuantity: number) => void;
  totalCurrency: string;
  translate: any;
};

const useStyles = makeStyles((theme: Theme) => ({
  addButton: {
    '& .buttonState': {
      alignItems: 'center',
      display: 'flex',
      flexFlow: 'row nowrap',
      justifyContent: 'space-between',
      width: '100%',
    },
  },

  addControls: {
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'column nowrap',
    width: '100%',

    '& .fd-quantity-control': {
      flexShrink: 0,
      marginBottom: theme.spacing(1),
    },
  },

  [theme.breakpoints.up('sm')]: {
    addControls: {
      flexFlow: 'row nowrap',

      '& .fd-quantity-control': {
        marginBottom: 0,
        marginRight: theme.spacing(2),
      },

      '& .MuiButton-fullWidth': {
        margin: theme.spacing(0, 0, 0, 1),
      },
    },
  },
}));

export function MenuDialogAddControls(props: Props): JSX.Element {
  const {
    itemName,
    handleAddItem,
    quantity,
    setQuantity,
    totalCurrency,
    translate,
  } = props;

  const classes = useStyles();

  return (
    <div className={classes.addControls}>
      <QuantityControl
        addItemButtonColor="secondary"
        isRemoveItemDisabled={quantity < 2}
        itemName={itemName}
        onAddItem={(): void => setQuantity(quantity + 1)}
        onRemoveItem={(): void => setQuantity(quantity - 1)}
        quantity={quantity}
        translate={translate}
      />

      <Button
        className={classes.addButton}
        data-fd="options-add-to-basket"
        onClick={(): void => handleAddItem(quantity)}
        fullWidth
      >
        <Typography variant="h3">
          {translate('RestaurantMenu_DialogCta_AddToBasket')}
        </Typography>
        <Typography variant="h3">{totalCurrency}</Typography>
      </Button>
    </div>
  );
}
